import { defineMessages } from 'react-intl';

import { ReportFilterFamilyKey, StudiesFilterMode } from './types';

export const studyTypeMessages = defineMessages({
  cbct: {
    id: 'studyType.cbct',
    defaultMessage: 'CBCT',
  },
  ioxRay: {
    id: 'studyType.ioxRay',
    defaultMessage: 'IOXRay',
  },
  pano: {
    id: 'studyType.pano',
    defaultMessage: 'Pano',
  },
  intraoralScan: {
    id: 'studyType.intraoralScan',
    defaultMessage: 'Intraoral Scan',
  },
  dentalPhotos: {
    id: 'studyType.dentalPhotos',
    defaultMessage: 'Dental Photos',
  },
  transcriptor: {
    id: 'studyType.transcriptor',
    defaultMessage: 'Transcriptor',
  },
});

export const studiesFilterModeMessages = defineMessages<StudiesFilterMode>({
  studies: {
    id: 'patientList.studies',
    defaultMessage: 'Studies',
  },
  reports: {
    id: 'patientList.reports',
    defaultMessage: 'Reports',
  },
});

export const reportFilterFamilyMessages = defineMessages<ReportFilterFamilyKey>(
  {
    cbct: {
      id: 'reportsFilter.family.cbct',
      defaultMessage: 'CBCT AI',
    },
    ioxray: {
      id: 'reportsFilter.family.ioxray',
      defaultMessage: 'IOXRay AI',
    },
    pano: {
      id: 'reportsFilter.family.pano',
      defaultMessage: 'Pano AI',
    },
    '3dModel': {
      id: 'reportsFilter.family.3dModel',
      defaultMessage: '3D Model AI',
    },
    superimposition: {
      id: 'reportsFilter.family.superimposition',
      defaultMessage: '3D Model AI + Superimposition',
    },
    implant: {
      id: 'reportsFilter.family.implant',
      defaultMessage: 'Implant AI',
    },
    ortho: {
      id: 'reportsFilter.family.ortho',
      defaultMessage: 'Ortho AI',
    },
    dentalPhotos: {
      id: 'reportsFilter.family.dentalPhotos',
      defaultMessage: 'Dental Photos',
    },
  },
);
